export default __webpack_public_path__ + "static/media/Dhipaya.ce00453a.png";